import { useEffect, useState } from "react";

import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  query,
  where,
} from "firebase/firestore";

import { db } from "../../firebase";

import {
  ArrowLeft,
  Plus,
  Trash2
} from "lucide-react";

import {
  useNavigate
} from "react-router-dom";

import {
  directIssue
} from "../../services/inventoryService";

export default function DirectIssue() {

  const navigate =
    useNavigate();

  const user =
    JSON.parse(
      localStorage.getItem("user") || "{}"
    );

  const companyId =
    user.company_id ||

    localStorage.getItem(
      "company_id"
    ) ||

    "";

  const [sites, setSites] =
    useState([]);

  const [inventory, setInventory] =
    useState([]);

  const [
    selectedSite,
    setSelectedSite
  ] = useState("");

  const [
    selectedProject,
    setSelectedProject
  ] = useState("");

  const [notes, setNotes] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [items, setItems] =
    useState([
      {

        item_id: "",

        item_code: "",

        category: "",

        item_name: "",

        unit: "",

        available: 0,

        quantity: 0,

        search: "",

        suggestions: [],
      }
    ]);

  const btnPrimary =
    "bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-90 text-white px-6 py-3 rounded-xl shadow-md font-medium flex items-center gap-2";

  const card =
    "bg-white rounded-2xl shadow-sm border border-slate-200 p-6";

  useEffect(() => {

    fetchSites();

    fetchInventory();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    const handleClickOutside =
      () => {

        setItems((prev) =>

          prev.map((row) => ({

            ...row,

            suggestions: [],
          }))
        );
      };

    document.addEventListener(
      "click",
      handleClickOutside
    );

    return () =>
      document.removeEventListener(
        "click",
        handleClickOutside
      );

  }, []);

  // =================================================
  // FETCH SITES
  // =================================================

  const fetchSites =
    async () => {

      try {

        const siteSnap =
          await getDocs(

            query(

              collection(
                db,
                "sites"
              ),

              where(
                "company_id",
                "==",
                companyId
              )
            )
          );

        const allSites =
          siteSnap.docs.map(
            (doc) => {

              const data =
                doc.data();

              return {

                id:
                  doc.id,

                site_name:
                  data.site_name ||
                  "Unnamed Site",

                project_name:
                  data.project_name ||

                  data.site_name ||

                  "",
              };
            }
          );

        setSites(allSites);

      } catch (error) {

        console.error(
          "Site Fetch Error:",
          error
        );
      }
    };

  // =================================================
  // FETCH INVENTORY
  // =================================================

  const fetchInventory =
    async () => {

      try {

        const itemQuery =
          query(

            collection(
              db,
              "items"
            ),

            where(
              "company_id",
              "==",
              companyId
            ),

            where(
              "is_active",
              "==",
              true
            )
          );

        const itemSnap =
          await getDocs(
            itemQuery
          );

        const stockSnap =
          await getDocs(

            query(

              collection(
                db,
                "inventory_summary"
              ),

              where(
                "company_id",
                "==",
                companyId
              )
            )
          );

        const stockMap = {};

        stockSnap.docs.forEach(
          (doc) => {

            const data =
              doc.data();

            stockMap[
              doc.id
            ] = Number(
              data.qty || 0
            );
          }
        );

        const inventoryList =
          itemSnap.docs.map(
            (doc) => {

              const item = {

                id:
                  doc.id,

                ...doc.data(),
              };

              return {

                ...item,

                qty:

                  stockMap[
                    item.item_id ||
                    item.id
                  ] ?? 0,
              };
            }
          );

        setInventory(
          inventoryList
        );

      } catch (error) {

        console.error(
          "Inventory Fetch Error:",
          error
        );
      }
    };

  // =================================================
  // HANDLE SITE
  // =================================================

  const handleSiteChange =
    (siteId) => {

      const site =
        sites.find(
          (s) =>
            s.id === siteId
        );

      setSelectedSite(
        siteId
      );

      setSelectedProject(

        site?.project_name ||

        ""
      );
    };

  // =================================================
  // HANDLE SEARCH
  // =================================================

  const handleSearch =
    (index, value) => {

      const updated =
        [...items];

      updated[index].search =
        value;

      updated[index].item_id =
        "";

      updated[index].item_code =
        "";

      updated[index].category =
        "";

      updated[index].item_name =
        "";

      updated[index].unit =
        "";

      updated[index].available =
        0;

      if (
        !value ||
        value.length < 1
      ) {

        updated[index]
          .suggestions = [];

        setItems(updated);

        return;
      }

      const lower =
        value.toLowerCase();

      const filtered =
        inventory

          .filter((i) => {

            const name =
              (
                i.item_name || ""
              ).toLowerCase();

            const code =
              (
                i.item_code || ""
              ).toLowerCase();

            return (

              name.includes(lower) ||

              code.includes(lower)
            );
          })

          .slice(0, 20);

      const uniqueMap = {};

      filtered.forEach(
        (item) => {

          const key =
            (
              item.item_name || ""
            )

              .toString()

              .toLowerCase()

              .trim();

          if (
            !uniqueMap[key]
          ) {

            uniqueMap[key] =
              item;
          }
        }
      );

      updated[index]
        .suggestions =

          Object.values(
            uniqueMap
          );

      setItems(updated);
    };

  // =================================================
  // SELECT ITEM
  // =================================================

  const selectItem =
    (
      index,
      item
    ) => {

      const alreadyExists =
        items.some(
          (row, i) =>

            row.item_id ===
              (
                item.item_id ||
                item.id
              ) &&

            i !== index
        );

      if (alreadyExists) {

        alert(
          "Item already added"
        );

        return;
      }

      const updated =
        [...items];

      updated[index] = {

        ...updated[index],

        item_id:

          item.item_id ||
          item.id,

        item_code:
          item.item_code || "",

        category:
          item.category || "",

        item_name:

          item.item_name ||

          "Unnamed Item",

        unit:

          item.unit ||

          "Nos",

        available:
          Number(
            item.qty || 0
          ),

        quantity: 0,

        suggestions: [],

        search:
          item.item_name,
      };

      setItems(updated);
    };

  // =================================================
  // HANDLE QTY
  // =================================================

  const handleQtyChange =
    (
      index,
      qty
    ) => {

      const updated =
        [...items];

      updated[index]
        .quantity =
          Number(qty);

      setItems(updated);
    };

  // =================================================
  // ADD ROW
  // =================================================

  const addItemRow =
    () => {

      const hasEmpty =
        items.some(
          (row) =>
            !row.item_id
        );

      if (hasEmpty) {

        alert(
          "Complete previous row first"
        );

        return;
      }

      setItems([

        ...items,

        {

          item_id: "",

          item_code: "",

          category: "",

          item_name: "",

          unit: "",

          available: 0,

          quantity: 0,

          search: "",

          suggestions: [],
        }
      ]);
    };

  // =================================================
  // REMOVE ROW
  // =================================================

  const removeItemRow =
    (index) => {

      if (
        items.length === 1
      ) return;

      setItems(

        items.filter(
          (_, i) =>
            i !== index
        )
      );
    };

  // =================================================
  // SAVE DIRECT ISSUE
  // =================================================

  const saveDirectIssue =
    async () => {

      try {

        setLoading(true);

        const selectedSiteObj =
          sites.find(
            (s) =>
              s.id ===
              selectedSite
          );

        const validItems =
          items.filter(
            (i) =>

              i.item_id &&

              Number(
                i.quantity
              ) > 0
          );

        if (

          !selectedSite ||

          validItems.length === 0

        ) {

          alert(
            "Select site & add valid items"
          );

          return;
        }

        // =============================================
        // SAVE DIRECT ISSUE HEADER
        // =============================================

        const issueRef =
          await addDoc(

            collection(
              db,
              "direct_issues"
            ),

            {

              company_id:
                companyId,

              site_id:
                selectedSiteObj?.id || "",

              site_name:
                selectedSiteObj?.site_name || "",

              project_name:
                selectedProject,

              notes,

              items:
                validItems,

              type:
                "direct_issue",

              created_by:
                user.id || "",

              created_at:
                serverTimestamp(),

              status:
                "issued",
            }
          );

        // =============================================
        // CENTRALIZED INVENTORY ENGINE
        // =============================================

        for (const item of validItems) {

          if (

            Number(
              item.quantity
            ) >

            Number(
              item.available || 0
            )

          ) {

            throw new Error(
              `${item.item_name} stock insufficient`
            );
          }

          await directIssue({

            company_id:
              companyId,

            item_id:
              item.item_id,

            item_code:
              item.item_code || "",

            item_name:
              item.item_name || "",

            category:
              item.category || "",

            qty:
              Number(
                item.quantity
              ),

            unit:
              item.unit || "",

            site_id:
              selectedSiteObj?.id || "",

            site_name:
              selectedSiteObj?.site_name || "",

            project_name:
              selectedProject || "",

            issued_by:
              user.id || "",

            reference_id:
              issueRef.id,

            reference_type:
              "direct_issue",

            remarks:
              notes || "",
          });
        }

        alert(
          "Direct Issue Saved Successfully"
        );

        navigate(
          "/inventory-ledger"
        );

      } catch (error) {

        console.error(
          "Direct Issue Save Error:",
          error
        );

        alert(

          error.message ||

          "Failed to save direct issue"
        );

      } finally {

        setLoading(false);
      }
    };

  return (

    <div className="p-6 min-h-screen bg-slate-50">

      <div
        className="relative"
        autoComplete="off"
        data-form-type="other"
        onClick={(e) =>
          e.stopPropagation()
        }
      />

      {/* HEADER */}

      <div className="flex items-center justify-between mb-6">

        <button
          onClick={() =>
            navigate(-1)
          }
          className="flex items-center gap-2 text-slate-600 hover:text-black"
        >

          <ArrowLeft size={18} />

          Back
        </button>

        <h1 className="text-2xl font-semibold text-slate-800">
          Direct Material Issue
        </h1>

        <div />
      </div>

      {/* SITE */}

      <div className={card}>

        <div className="grid md:grid-cols-2 gap-4">

          <select
            value={
              selectedSite
            }
            onChange={(e) =>
              handleSiteChange(
                e.target.value
              )
            }
            className="border border-slate-200 focus:ring-2 focus:ring-cyan-400 rounded-xl p-3 bg-slate-50"
          >

            <option value="">
              Select Site
            </option>

            {sites.map(
              (site) => (

                <option
                  key={site.id}
                  value={site.id}
                >
                  {site.site_name}
                </option>
              )
            )}
          </select>

          <input
            value={
              selectedProject
            }
            readOnly
            placeholder="Project Auto Selected"
            className="border border-slate-200 focus:ring-2 focus:ring-cyan-400 rounded-xl p-3 bg-slate-100"
          />
        </div>
      </div>

      {/* ITEMS */}

      <div className={`${card} mt-6`}>

        <div className="overflow-visible">

          <table className="w-full border-collapse">

            <thead>

              <tr className="bg-slate-100 text-slate-700">

                <th className="p-3 text-left">
                  Item
                </th>

                <th className="p-3 text-left">
                  Unit
                </th>

                <th className="p-3 text-left">
                  Available
                </th>

                <th className="p-3 text-left">
                  Issue Qty
                </th>

                <th className="p-3 text-left">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>

              {items.map(
                (
                  row,
                  index
                ) => (

                  <tr
                    key={index}
                    className="border-b"
                  >

                    <td className="p-3">

                      <div
                        className="relative"
                        onClick={(e) =>
                          e.stopPropagation()
                        }
                      >

                        <form autoComplete="new-password">

                          <input
                            type="search"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            inputMode="search"
                            placeholder="Search Item"
                            value={
                              row.search
                            }
                            onChange={(e) =>
                              handleSearch(

                                index,

                                e.target.value
                              )
                            }
                            className="border rounded-lg p-2 w-full"
                          />
                        </form>

                        {row.suggestions
                          ?.length > 0 && (

                          <div
                            className="absolute left-0 top-full mt-1 bg-white border rounded-lg shadow-xl w-full max-h-60 overflow-y-auto"
                            style={{
                              zIndex: 99999
                            }}
                          >

                            {row.suggestions

                              .slice(0, 20)

                              .map((inv) => (

                                <div
                                  key={inv.id}
                                  onClick={() =>
                                    selectItem(
                                      index,
                                      inv
                                    )
                                  }
                                  className="p-2 hover:bg-cyan-50 cursor-pointer border-b"
                                >

                                  {inv.item_name}

                                  {" | "}

                                  {inv.item_code}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </td>

                    <td className="p-3">
                      {row.unit || "-"}
                    </td>

                    <td className="p-3">
                      {row.available}
                    </td>

                    <td className="p-3">

                      <input
                        type="number"
                        min="0"
                        max={
                          row.available
                        }
                        value={
                          row.quantity
                        }
                        onChange={(e) =>
                          handleQtyChange(

                            index,

                            e.target.value
                          )
                        }
                        className="border rounded-lg p-2 w-24"
                      />
                    </td>

                    <td className="p-3">

                      <button
                        onClick={() =>
                          removeItemRow(
                            index
                          )
                        }
                        className="text-red-500"
                      >

                        <Trash2 size={18} />
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        <button
          onClick={addItemRow}
          className="mt-4 flex items-center gap-2 text-cyan-600 font-medium"
        >

          <Plus size={18} />

          Add Item
        </button>
      </div>

      {/* NOTES */}

      <div className={`${card} mt-6`}>

        <textarea
          value={notes}
          onChange={(e) =>
            setNotes(
              e.target.value
            )
          }
          rows="4"
          placeholder="Notes"
          className="w-full border border-slate-200 focus:ring-2 focus:ring-cyan-400 rounded-xl p-4"
        />
      </div>

      {/* SAVE */}

      <div className="mt-6">

        <button
          onClick={
            saveDirectIssue
          }
          disabled={loading}
          className={
            btnPrimary
          }
        >

          {

            loading

              ? "Saving..."

              : "Save Direct Issue"
          }
        </button>
      </div>
    </div>
  );
}